
export default {
  data() {
    return {
      folderName: "/screen-1440",
      controls: false,
    };
  },
  computed: {
    backgroundImageStyle() {
      return {
        backgroundImage: `url('/about-us/${this.folderName}/about-us-hero-section-img.png')`,
      };
    },
  },
  mounted() {
    if (process.browser) {
      if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        this.folderName = "/screen-768";
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        this.folderName = "/screen-1024";
      } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        this.folderName = "/screen-1440";
      } else if (window.innerWidth >= 1920 && window.innerWidth < 2500) {
        this.folderName = "/screen-1920";
      } else if (window.innerWidth >= 2500) {
        this.folderName = "/screen-2500";
      } else {
        this.folderName = "/screen-375";
      }

      window.addEventListener("resize", this.onResize);
    }
  },
  methods: {
    showVideoControls() {
      this.controls = true;
    },
    hideVideoControls() {
      this.controls = false;
    },
    onResize() {
      if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        this.folderName = "/screen-768";
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        this.folderName = "/screen-1024";
      } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        this.folderName = "/screen-1440";
      } else if (window.innerWidth >= 1920 && window.innerWidth < 2500) {
        this.folderName = "/screen-1920";
      } else if (window.innerWidth >= 2500) {
        this.folderName = "/screen-2500";
      } else {
        this.folderName = "/screen-375";
      }
    },
  },
};
